module.exports = __webpack_public_path__ + "static/media/Junction.svg";